import { useSelector } from 'react-redux';
import { getI18n, setupI18n } from '../../libs/i18n';
import { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { getFrontendRuntimeContext } from '../../libs/frontendRuntimeContext';

export interface I18nProviderProps {
  children?: ReactNode;
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const localeConfig = useSelector((state: any) => state.localeConfig);
  if (!getFrontendRuntimeContext()) {
    setupI18n(localeConfig);
  }
  return <I18nextProvider i18n={getI18n()}>{children}</I18nextProvider>;
};
